import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessingStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Gesamt',
      value: stats?.total,
      icon: 'FileText',
      color: 'text-foreground',
      bgColor: 'bg-muted/50'
    },
    {
      label: 'Unbestätigt',
      value: stats?.unconfirmed,
      icon: 'AlertCircle',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-100'
    },
    {
      label: 'Bestätigt',
      value: stats?.confirmed,
      icon: 'CheckCircle',
      color: 'text-cyan-600',
      bgColor: 'bg-cyan-100'
    },
    {
      label: 'Beantragt',
      value: stats?.applied,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Genehmigt',
      value: stats?.approved,
      icon: 'CheckCircle2',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Abgelehnt',
      value: stats?.rejected,
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4">
      {statCards?.map((stat) => (
        <div
          key={stat?.label}
          className="bg-card rounded-lg shadow-card p-6 border border-border hover:shadow-lg transition-smooth"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} color={`var(--color-${stat?.color?.replace('text-', '')})`} />
            </div>
          </div>
          <p className="text-3xl font-heading font-bold text-foreground mb-1">
            {stat?.value}
          </p>
          <p className="text-sm text-muted-foreground">{stat?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default ProcessingStats;